import { ReactNode } from 'react';

import ReactModal from 'react-modal';
import { useModal } from 'react-modal-hook';

import './styles/video.scss';
import CloseBtn from '../buttons/button-close';
import WistiaVideo from '../video/wistia-player';

ReactModal.setAppElement('#___gatsby');

type Props = {
  autoPlay?: boolean,
  className?: string,
  hashedId: string,
  icon?: string,
  modalOpenedCallback?: () => void,
  noRender?: boolean
  text?: string,
  title?: string
  children?: ReactNode
}

const VideoModal = (props:Props) => {

  const {
    className,
    title,
    icon,
    text,
    noRender,
    children,
    hashedId,
    autoPlay,
  } = props;

  const [showModal, hideModal] = useModal(
    ({ onExited }) => {
      return (
        <ReactModal
          isOpen
          onAfterClose={ onExited }
          onRequestClose={ hideModal }
          className="default-modal-wrapper video-modal"
          overlayClassName="default-modal-overlay"
        >
          <div data-section="videoModal">
            <CloseBtn
              className="close-btn"
              onClick={ hideModal }
            ></CloseBtn>
            <WistiaVideo hashedId={ hashedId } autoPlay={ !!autoPlay } />
          </div>
        </ReactModal>
      );
    },
    [hashedId, autoPlay]
  );

  const handleShowModal = () => {
    showModal();

    if (props.modalOpenedCallback) {
      props.modalOpenedCallback();
    }
  };

  if (text) {
    return (
      <button
        className={ className || '' }
        onClick={ handleShowModal }
        title={ title }
      >
        {icon && icon}
        {text}
      </button>
    );
  } else if (noRender) {
    return (
      <button className={ className } onClick={ handleShowModal }>
        {children}
      </button>
    );
  } else {
    return (
      <button type="button" className="video-modal-play-button play-btn" onClick={ handleShowModal }>
        <svg
          className="svg-inline--fa fa-play fa-w-14"
          aria-hidden="true"
          focusable="false"
          data-prefix="fa"
          data-icon="play"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="white"
            d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
          ></path>
        </svg>
      </button>
    );
  }
};

export default VideoModal;
